// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__4M6l2","title":"styles_title__2n4iY"};